import { useModulePermission } from '@sdx/b2o-fe-tools';
import type { ModuleName } from '@sdx/b2o-fe-tools';

type UseAdminPanelPermissionProps = {
  accessToken: string | null;
  baseUrl: string;
  siteCode?: string;
};

type AdminPanelPermissionState = {
  isChecking: boolean;
  hasAccess: boolean | null;
};

const ADMINPANEL_MODULE: ModuleName = 'adminpanel';

export const useAdminPanelPermission = ({
  accessToken,
  baseUrl,
  siteCode,
}: UseAdminPanelPermissionProps): AdminPanelPermissionState => {
  const { permissions, isLoading, hasError, canExecute } = useModulePermission(ADMINPANEL_MODULE, {
    baseUrl,
    accessToken: accessToken ?? undefined,
    siteCode: siteCode ?? undefined,
  });

  if (!canExecute || isLoading) {
    return { isChecking: true, hasAccess: null };
  }

  if (hasError || !permissions) {
    return { isChecking: false, hasAccess: false };
  }

  return { isChecking: false, hasAccess: permissions.canRead };
};
